const warnedInvalidCaseRecords = new Set()

export const isValidCaseRecord = (content = {}) => {
  return !!(
    content &&
    typeof content === 'object' &&
    content.user &&
    typeof content.user === 'object' &&
    content.user.uid &&
    content.createAt
  )
}

export const warnInvalidCaseRecordOnce = (key, content = {}, logger = console.warn) => {
  const warnKey = `case:${key}`
  if (warnedInvalidCaseRecords.has(warnKey)) return

  warnedInvalidCaseRecords.add(warnKey)
  logger('Skipped invalid case record', {
    key,
    keys: Object.keys(content || {}),
  })
}

export const filterValidCaseRecords = (items = [], logger = console.warn) => {
  return items.filter((content) => {
    if (isValidCaseRecord(content)) return true
    warnInvalidCaseRecordOnce(content?.key || '(unknown)', content, logger)
    return false
  })
}

export const collectValidCasePage = async ({
  perPage = 5,
  cursorKey = null,
  scanLimit = Math.max(perPage + 5, 20),
  fetchChunk,
  logger = console.warn,
}) => {
  if (typeof fetchChunk !== 'function') {
    throw new Error('fetchChunk is required')
  }

  let nextQueryCursor = cursorKey
  let scannedToEnd = false
  let validCases = []

  while (validCases.length <= perPage && !scannedToEnd) {
    const currentCursor = nextQueryCursor
    const rawCases = await fetchChunk({
      cursorKey: currentCursor,
      limit: currentCursor ? scanLimit + 1 : scanLimit,
    })

    let pageChunk = Array.isArray(rawCases) ? rawCases : []
    if (currentCursor) {
      pageChunk = pageChunk.filter((content) => content.key !== currentCursor)
    }

    if (pageChunk.length <= 0) {
      scannedToEnd = true
      break
    }

    validCases = validCases.concat(filterValidCaseRecords(pageChunk, logger))
    nextQueryCursor = pageChunk[pageChunk.length - 1].key
    scannedToEnd = pageChunk.length < scanLimit
  }

  const cases = validCases.slice(0, perPage)
  return {
    cases,
    hasNext: validCases.length > perPage,
    nextCursor: cases.length > 0 ? cases[cases.length - 1].key : null,
  }
}
